import { createContext } from 'react'
import { IResellerModifiedUnion } from 'src/@interfaces'

export interface ResellerContextProps {
  reseller: IResellerModifiedUnion | undefined
  isGenericUser: boolean
}

export const ResellerContext = createContext<ResellerContextProps | undefined>(undefined)

export const ResellerProvider = ResellerContext.Provider
